// extracted by mini-css-extract-plugin
module.exports = {"root":"_79418c","container":"_d49386","logoLink":"_197390","logoContainer":"_ba0095","headlineContainer":"_92a344","link":"_0a553a","button":"_901846","description":"_054e38"};